import React from 'react';
import PropTypes from 'prop-types';

import SimplePanel from '@/shared/components/SimplePanel';
import OverlayTrigger from 'react-bootstrap/lib/OverlayTrigger';
import Popover from 'react-bootstrap/lib/Popover';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FaInfoCircle } from 'react-icons/fa';
import FileUpload from '@/shared/components/input/FileUpload';
import dataCacheService from '@/shared/services/DataCacheService';
import classNames from 'classnames';
import messages from './documentMessages';

const Dropzone = ({
  documentUploadEndpoint,
  onDocumentUploaded,
  onAdvancedUpload,
  onLinkFromSharepoint,
  intl,
  ...rest
}) => (
  <div className={classNames('simple-panel')}>
    <div className={classNames('panel-title')} {...rest}>
      <span>
        <FormattedMessage {...messages.Dropzone} />

        <OverlayTrigger
          trigger={['hover', 'focus']}
          placement="bottom"
          rootClose
          overlay={
            <Popover id="popover-trigger-hover-focus">
              {intl.formatMessage(messages.DropzoneExplanation)}
            </Popover>
          }
        >
          <span className="margin10L explanation-icon">
            <FaInfoCircle />
          </span>
        </OverlayTrigger>
      </span>
    </div>
    <div className={classNames('simple-panel-body')}>
      <div className="file-upload-wrapper">
        <FileUpload
          endpoint={documentUploadEndpoint}
          onFileUploaded={(error, file) => onDocumentUploaded(error, file)}
          {...rest}
        />
      </div>
      <div className="dms-advanced-upload">
        <div className="dms-advanced-upload-content">
          <label className="bold clickable underline" onClick={onAdvancedUpload}>
            {intl.formatMessage(messages.ClickForAdvancedUpload)}
          </label>
        </div>
        {dataCacheService.hasConnectPlatform(null, 31) && (
          <div className="dms-advanced-upload-content">
            <label className="bold clickable underline" onClick={onLinkFromSharepoint}>
              {intl.formatMessage(messages.LinkFromSharepoint)}
            </label>
          </div>
        )}
      </div>
    </div>
  </div>
);

Dropzone.propTypes = {
  documentUploadEndpoint: PropTypes.string.isRequired,
  onDocumentUploaded: PropTypes.func.isRequired,
  onAdvancedUpload: PropTypes.func.isRequired,
  onLinkFromSharepoint: PropTypes.func.isRequired,
};

export default injectIntl(Dropzone);
